import { render } from "./ButtonGroup.vue?vue&type=template&id=a52a726c&scoped=true"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts"

import "./ButtonGroup.vue?vue&type=style&index=0&id=a52a726c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a52a726c"

export default script